import React from 'react';

import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { CardNumerico } from 'view/component/Cards/CardNumerico/CardNumerico';
import { AiOutlineFileSync } from "react-icons/ai";
import { FiUser } from 'react-icons/fi';
import { SituacaoTag } from 'view/component/Situacao/SituacaoTag';
import { Situacoes } from 'model/solicitacao/Situacao';
import { MdErrorOutline } from 'react-icons/md';
import { BotaoCard } from 'view/component/Cards/BotaoCard/BotaoCard';
import { Destaque } from 'view/component/Destaque/Destaque';
import { PainelCards, ItemPainel } from 'view/component/Cards/PainelCards/PainelCards';
import { H2, H3 } from 'view/component/Tipografia/Texto';
import { Conteudo } from 'view/section/Conteudo/Conteudo';


export const SLAPage: React.FunctionComponent = () => {

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem>Painel SLA</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo>
        <section>
          <H2>Painel <abbr title="Acordo de nível de serviço">SLA</abbr></H2>

          https://colorlib.com/wp/free-bootstrap-admin-dashboard-templates/

          <p>Média das notas</p>

          https://fr.slideshare.net/ChristineShahin/introducing-excel-as-a-powerfull-tool
          Google it: SLA dashboard
          
          <PainelCards>
            <ItemPainel>
              <BotaoCard navlink={{to: '/solicitacoes'}} icone={FiUser}><Destaque>25</Destaque> solicitações sem responsável técnico</BotaoCard>
            </ItemPainel>
            <ItemPainel>
            <BotaoCard navlink={{to: '/solicitacoes'}} icone={AiOutlineFileSync}><Destaque>25</Destaque> solicitações <SituacaoTag situacao={Situacoes.EM_ABERTO} /> com responsável técnico definido</BotaoCard>
              </ItemPainel>
            <ItemPainel>
              <BotaoCard navlink={{to: '/solicitacoes'}} icone={MdErrorOutline}><Destaque>25</Destaque> solicitações violando o <abbr title="Acordo de nível de serviço">SLA</abbr></BotaoCard>
            </ItemPainel>
            <ItemPainel>
              <CardNumerico
                textoSuperior="Média de"
                textoCentral={<>13 dias</>}
                textoInferior="para o início do atendimento"
              />
            </ItemPainel>
            <ItemPainel>
              <CardNumerico
                textoSuperior="Média de"
                textoCentral={<>1 mês</>}
                textoInferior="para a conclusão de um atendimento (gráfico de quartis ou histograma)"
              />
            </ItemPainel>
          </PainelCards>

          <img src="https://www.opservices.com.br/wp-content/uploads/2017/08/ServiceDesk-FM-1024x606.png" alt="Exemplo de painel SLA" />
        </section>

        <section>
          <H3>Solicitações da divisão (N1/N2)</H3>
          {/* <SolicitacoesLista updateFiltros={() => {}} />  */}
        </section>
      </Conteudo>
    </>
  )
}

